var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuickSearchNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200.044,
    height: 147.475
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quick-search-not-found_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#quick-search-not-found_svg__a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "quick-search-not-found_svg__e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#quick-search-not-found_svg__b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "quick-search-not-found_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#quick-search-not-found_svg__c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.418 98.215C41.841 99.79 6.11 109.864 6.053 122.245c-.062 13.659 43.312 24.953 96.882 25.225 5.013.026 9.937-.046 14.744-.209 46.583-1.574 82.311-11.649 82.365-24.029.064-13.659-43.312-24.955-96.88-25.226q-7.523-.038-14.746.209",
    fill: "#efecfd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.737 19.256)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1 copy",
    d: "M47.595 0h74.276a20 20 0 0120 20v39.112a20 20 0 01-20 20H47.595a20 20 0 01-20-20V20a20 20 0 0120-20z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1 copy 3",
    width: 114.276,
    height: 79.112,
    rx: 20,
    transform: "translate(34.592 10.473)",
    fill: "#cdc4ff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1 copy",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.595 0h74.276a20 20 0 0120 20v39.112a20 20 0 01-20 20H47.595a20 20 0 01-20-20V20a20 20 0 0120-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.595 4a15.895 15.895 0 00-11.314 4.686A15.895 15.895 0 0031.595 20v39.112c0 4.274 1.664 8.292 4.686 11.314a15.895 15.895 0 0011.314 4.686h74.276c4.274 0 8.292-1.664 11.314-4.686a15.895 15.895 0 004.686-11.314V20c0-4.274-1.664-8.292-4.686-11.314A15.895 15.895 0 00121.871 4H47.595m0-4h74.276c11.046 0 20 8.954 20 20v39.112c0 11.046-8.954 20-20 20H47.595c-11.046 0-20-8.954-20-20V20c0-11.046 8.954-20 20-20z",
    fill: "#5f48e9"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1 copy 2",
    d: "M20 25.942h74.276a20 20 0 0120 20v39.112a20 20 0 01-20 20H20a20 20 0 01-20-20V45.942a20 20 0 0120-20z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 25.942h74.276a20 20 0 0120 20v39.112a20 20 0 01-20 20H20a20 20 0 01-20-20V45.942a20 20 0 0120-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 29.942a15.895 15.895 0 00-11.314 4.686A15.895 15.895 0 004 45.942v39.112c0 4.274 1.664 8.292 4.686 11.314A15.895 15.895 0 0020 101.054h74.276c4.274 0 8.292-1.664 11.314-4.686a15.895 15.895 0 004.686-11.314V45.942c0-4.274-1.664-8.292-4.686-11.314a15.895 15.895 0 00-11.314-4.686H20m0-4h74.276c11.046 0 20 8.954 20 20v39.112c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20V45.942c0-11.046 8.954-20 20-20z",
    fill: "#5f48e9"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2",
    transform: "translate(115.178 121.174)",
    stroke: "#5f48e9",
    strokeWidth: 7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "quick-search-not-found_svg__a",
    width: 45.843,
    height: 3.137,
    rx: 1.568,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.363h45.843m-3.5.363v3.137m3.5.363H0m3.5-.363V0",
    clipPath: "url(#quick-search-not-found_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2 copy",
    transform: "translate(168.259 121.174)",
    stroke: "#5f48e9",
    strokeWidth: 7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "quick-search-not-found_svg__b",
    width: 13.994,
    height: 3.137,
    rx: 1.568,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.363h13.994m-3.5.363v3.137m3.5.363H0m3.5-.363V0",
    clipPath: "url(#quick-search-not-found_svg__e)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2 copy 2",
    transform: "translate(4.191 84.982)",
    stroke: "#5f48e9",
    strokeWidth: 7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "quick-search-not-found_svg__c",
    width: 13.994,
    height: 3.137,
    rx: 1.568,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.363h13.994m-3.5.363v3.137m3.5.363H0m3.5-.363V0",
    clipPath: "url(#quick-search-not-found_svg__f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.711 67.066)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 2",
    d: "M48.801 68.258a3.429 3.429 0 01-2.159-1.543L37.39 51.908l5.813-3.756L52.46 62.96a3.534 3.534 0 01.456 2.642 3.479 3.479 0 01-1.514 2.2 3.376 3.376 0 01-1.838.546 3.416 3.416 0 01-.763-.09zM35.942 47.676a3.489 3.489 0 011.513-2.194 3.369 3.369 0 012.6-.461 3.419 3.419 0 012.005 1.325l-5.792 3.743a3.55 3.55 0 01-.326-2.413z",
    fill: "#d8dbe9"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 19.785,
    cy: 19.785,
    transform: "translate(1.843 1.991)",
    r: 19.785,
    fill: "#d8dbe9"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1 copy",
    cx: 15.924,
    cy: 15.924,
    r: 15.924,
    transform: "translate(5.703 5.852)",
    fill: "#f9faff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Search",
    d: "M48.126 69.193a5.309 5.309 0 01-3.378-2.311L34.7 51.484a5.32 5.32 0 01-.756-4.025 5.387 5.387 0 01.336-1.059.954.954 0 01-.07-.093l-3.382-5.182a21.63 21.63 0 114.9-3.207l3.382 5.183a1.093 1.093 0 01.058.1 5.435 5.435 0 011.1.115 5.311 5.311 0 013.379 2.311L53.7 61.03a5.353 5.353 0 01-4.465 8.279 5.391 5.391 0 01-1.109-.116zM37.373 51.865l9.074 13.906A3.317 3.317 0 0052 62.141l-9.075-13.906zm-.012-6.085a3.319 3.319 0 00-1.091 4.378l5.53-3.617a3.311 3.311 0 00-4.443-.761zm-4.735-5.611l2.914 4.465a5.366 5.366 0 011.505-.984l-2.914-4.466q-.731.524-1.505.984zM2.449 17.592a19.54 19.54 0 1019.136-15.56 19.6 19.6 0 00-19.136 15.56zm15.6 20.924a17.241 17.241 0 113.547.37 17.292 17.292 0 01-3.549-.37zM6.688 18.482a15.212 15.212 0 1014.9-12.114 15.258 15.258 0 00-14.9 12.114zm4.146 9.66a1.014 1.014 0 01-.691-.522 12.946 12.946 0 016.773-18.073 1.016 1.016 0 01.736 1.894 10.913 10.913 0 00-5.711 15.235 1.015 1.015 0 01-1.107 1.467zm12.993-17.205a11.006 11.006 0 00-1.977-.231 1.033 1.033 0 01-.184-.021 1.016 1.016 0 01.235-2.01 13 13 0 012.342.273 1.016 1.016 0 11-.417 1.989z",
    fill: "#5f48e9"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 1",
    d: "M13.414 45.171a2.775 2.775 0 112.775-2.775 2.778 2.778 0 01-2.775 2.775zm0-4.895a2.12 2.12 0 102.12 2.12 2.122 2.122 0 00-2.12-2.12z",
    fill: "#5f48e9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 2",
    d: "M45.662 8.362l-1.664-2.441h-2.953l1.806-2.35-.9-2.818 2.78.989 2.4-1.74-.088 2.961 2.382 1.742-2.835.842zm-1.275-3.178l1.043 1.53.579-1.765 1.777-.528-1.493-1.092.055-1.856-1.5 1.09-1.743-.62.565 1.766-1.132 1.473z",
    fill: "#5f48e9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 2 copy",
    d: "M197.52 55.231l-2.954-.055-1.71 2.408-.872-2.833-2.82-.9 2.415-1.7-.033-2.961 2.365 1.785 2.8-.935-.953 2.8zm-3.329-.8l1.851.034-1.1-1.494.6-1.754-1.755.586-1.482-1.119.02 1.856-1.514 1.063 1.767.561.547 1.776z",
    fill: "#5f48e9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 4",
    d: "M128.131 4.839V2.445h-1.238v2.394h-2.394v1.239h2.394v2.394h1.239V6.078h2.394V4.839z",
    fill: "#5f48e9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 4 copy",
    d: "M3.632 101.109v-2.394H2.394v2.394H0v1.239h2.394v2.394h1.239v-2.394h2.394v-1.239z",
    fill: "#5f48e9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 5",
    d: "M182.958 22.488v-3.689h1.108v3.689zm3.61-4.725l.783-.783 2.609 2.609-.783.783zm-9.5 1.827l2.609-2.609.783.783-2.612 2.609zm11.319-5.112V13.37h3.689v1.108zm-13.439 0V13.37h3.689v1.108zm11.621-4.392l2.609-2.609.783.783-2.613 2.609zm-9.504-1.826l.783-.783 2.609 2.609-.783.783zm5.893.789V5.36h1.108v3.689z",
    fill: "#efecfd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape 7",
    d: "M184.476 94.872l-1.236-2.261-2.261-1.236 2.261-1.236 1.236-2.261 1.236 2.261 2.264 1.233-2.261 1.236z",
    fill: "#5f48e9"
  }))));
}

export default SvgQuickSearchNotFound;